import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ColorScale from '_class/ColorScale';
import { getVerdictScales } from 'actions/studyplans';
import { verdictIndexColors } from 'constants/colors';
import { translate, getActiveLanguage } from '@haldor/ui';
import '../Verdict.scss';
var VerdictWidget = /*#__PURE__*/function (_Component) {
  function VerdictWidget() {
    var _this;
    _classCallCheck(this, VerdictWidget);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, VerdictWidget, [].concat(args));
    _defineProperty(_this, "componentDidMount", function () {
      if (_this.props.scales == null) {
        _this.props.getVerdictScales(_this.props.activeStudent.id, getActiveLanguage());
      }
    });
    _defineProperty(_this, "getScale", function (scaleId) {
      if (_this.props.scales == null || _this.props.scales.length == 0) {
        return null;
      }
      var found = _this.props.scales.find(function (scale) {
        return scale.id == scaleId;
      });
      if (found != null) {
        return found;
      }
      return _this.props.scales[0];
    });
    return _this;
  }
  _inherits(VerdictWidget, _Component);
  return _createClass(VerdictWidget, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      if (this.props.verdict == null) {
        return null;
      }
      var scale = this.getScale(this.props.verdict.scaleId);
      if (scale == null) {
        return null;
      }
      var translate = this.props.translate;
      var colors = new ColorScale(scale.levels.length).get();
      return /*#__PURE__*/React.createElement("div", {
        className: "verdict verdict-widget"
      }, /*#__PURE__*/React.createElement("div", {
        className: "verdict-levels"
      }, scale.levels.map(function (cell) {
        var styles = {};
        if (_this2.props.verdict != null) {
          if (cell.id == _this2.props.verdict.scaleLevelId) {
            styles = {
              backgroundColor: cell.colorCode != null ? cell.colorCode : colors[cell.level]
            };
          }
        }
        return /*#__PURE__*/React.createElement("div", {
          key: cell.id,
          style: styles,
          className: "level-dot"
        });
      })), /*#__PURE__*/React.createElement("div", {
        className: "level-text"
      }, scale.levels.map(function (cell, index) {
        if (_this2.props.verdict != null) {
          if (cell.id == _this2.props.verdict.scaleLevelId) {
            var levelText = "";
            if (index == 0) {
              levelText = translate('Not acceptable level of knowledge');
            }
            if (index == 1) {
              levelText = translate('Has reached an acceptable level of knowledge');
            }
            if (index == 2) {
              levelText = translate('Reaching more than an acceptable level of knowledge');
            }
            return /*#__PURE__*/React.createElement("span", {
              key: cell.id
            }, cell.shortLocalizationText != null ? cell.shortLocalizationText : levelText);
          }
        }
        return null;
      })));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    activeStudent: state.User.activeStudent,
    scales: state.studyplans.scales,
    currentStudent: state.guardians.currentStudent,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {
  getVerdictScales: getVerdictScales
})(VerdictWidget);